<template>
  <div class="container">
    <div
      class="our-blog our-blog-1 section-padding-top sections product-items-container row"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="guardianship">
              <h2>流程介绍详细说明</h2>
              <p>
                申请材料 : 未成年人用户家长监护服务申请书
                <a class="download" href="未成年人用户家长监护服务申请书.rar"
                  >下载</a
                >
              </p>
              <p>
                温馨提醒，您在邮寄申请书时，要记得一起提供如下资料：<br />附件1：申请人的身份证或户口本（复印件）<br />附件2：被申请人的身份证或户口本（复印件）<br />附件3：申请人与被申请人的监护法律关系证明（原件）
              </p>

              <p style="text-align: center">
                <img
                  class="img-responsive"
                  src="../../../../assets/img/img_lc.jpg"
                  alt="Image"
                />
              </p>
              <h4>监护人提出申请</h4>
              <P
                >在监护人发现被监护人有沉溺极峰网络科技有限公司游戏的情况下，监护人可向极峰网络科技有限公司申请发起未成年人家长监护机制。</P
              >
              <p>
                监护人需亲自通过邮寄方式向我司提供有效材料，向杭州极峰网络科技有限公司提出未成年人账户监控的申请。在收到邮件后，我司即开始启动监护机制审核流程，首先进入疑似账号身份确认期。
              </p>
              <h4>疑似账号身份确认期（15 个自然日）</h4>
              <p>
                在判断申请材料完整的情况下，我司将通过官方邮箱联系疑似帐号归属者，告知其在
                15
                个自然日内将按照监护人需求对其账号进行相关操作，并要求疑似账号归属者提供身份材料以便我司判定其与监护人监护关系；
              </p>
              <p>
                若疑似账号归属者在 15
                个自然日内不能提供有效身份证明或逾期提供，则默认为疑似账号归属者与被监护人身份相符。我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；
              </p>
              <p>
                若疑似账号归属者在 15
                个自然日内提供的身份证明与被监护人相符，我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；
              </p>
              <p>
                若疑似账号归属者在 15
                个自然日内提供的身份证明与被监护人不符，我司则无法判定其与被监护人的身份关系。在此情况下，为保障用户游戏账号安全，我司将通知监护人通过公安机关出具账号找回协查证明，由我司协助被监护人找回游戏账号后再进行后续操作；
              </p>
              <h4>季度报告</h4>
              <p>
                我公司游戏平台会在每季度末向浙江省文化行政部门提交”家长监护工程“情况报告，报告内容包括咨询数量、申请数量、受理与完成情况、重点案例分析、疑难问题说明、对于工程实施中出现的问题提出意见和建议。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    //这里存放数据
    return {};
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {},
};
</script>
<style lang="less" scoped>
@import url("../../index.less");
</style>
